module.exports = __webpack_public_path__ + "img/20.15dfdd9a.png";